import 'globals';

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.lightGallery) {
            $('.light-gallery').lightGallery({
                download: false,
                thumbnail: true,
                subHtmlSelectorRelative: true,
                selector: '.gallery__item'
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
